module.exports = "<ssf-paginable-list [list]=\"enabledApplicationList$\"\n                    [pageSize]=\"pageSize\"\n                    [adapter]=\"adapter\"\n                    (loadPage)=\"onLoadPage($event)\">\n</ssf-paginable-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/applications/components/enabled-application-list/enabled-application-list.component.html
// module id = 825
// module chunks = 3